export var StochasticZone;
(function (StochasticZone) {
    StochasticZone["extremeOversold"] = "extremeOversold";
    StochasticZone["oversold"] = "oversold";
    StochasticZone["neutral"] = "neutral";
    StochasticZone["overbought"] = "overbought";
    StochasticZone["extremeOverbought"] = "extremeOverbought";
})(StochasticZone || (StochasticZone = {}));
export var StochasticLinePosition;
(function (StochasticLinePosition) {
    StochasticLinePosition["aboveD"] = "aboveD";
    StochasticLinePosition["belowD"] = "belowD";
    StochasticLinePosition["equal"] = "equal";
})(StochasticLinePosition || (StochasticLinePosition = {}));
export var StochasticGapTrend;
(function (StochasticGapTrend) {
    StochasticGapTrend["widening"] = "widening";
    StochasticGapTrend["narrowing"] = "narrowing";
    StochasticGapTrend["stable"] = "stable";
})(StochasticGapTrend || (StochasticGapTrend = {}));
export var StochasticTrend;
(function (StochasticTrend) {
    StochasticTrend["risingFast"] = "risingFast";
    StochasticTrend["rising"] = "rising";
    StochasticTrend["flat"] = "flat";
    StochasticTrend["falling"] = "falling";
    StochasticTrend["fallingFast"] = "fallingFast";
})(StochasticTrend || (StochasticTrend = {}));
export var StochasticCrossDirection;
(function (StochasticCrossDirection) {
    StochasticCrossDirection["bullish"] = "bullish";
    StochasticCrossDirection["bearish"] = "bearish";
})(StochasticCrossDirection || (StochasticCrossDirection = {}));
export var StochasticEmbeddedState;
(function (StochasticEmbeddedState) {
    StochasticEmbeddedState["none"] = "none";
    StochasticEmbeddedState["upper"] = "upper";
    StochasticEmbeddedState["lower"] = "lower";
})(StochasticEmbeddedState || (StochasticEmbeddedState = {}));
export var StochasticEventType;
(function (StochasticEventType) {
    StochasticEventType["bullishCross"] = "bullishCross";
    StochasticEventType["bearishCross"] = "bearishCross";
    StochasticEventType["bullishCrossInOversold"] = "bullishCrossInOversold";
    StochasticEventType["bearishCrossInOverbought"] = "bearishCrossInOverbought";
    StochasticEventType["exitedOversold"] = "exitedOversold";
    StochasticEventType["exitedOverbought"] = "exitedOverbought";
    StochasticEventType["bullishCrossExitOversold"] = "bullishCrossExitOversold";
    StochasticEventType["bearishCrossExitOverbought"] = "bearishCrossExitOverbought";
    StochasticEventType["crossedAbove50"] = "crossedAbove50";
    StochasticEventType["crossedBelow50"] = "crossedBelow50";
    StochasticEventType["becameEmbeddedUpper"] = "becameEmbeddedUpper";
    StochasticEventType["becameEmbeddedLower"] = "becameEmbeddedLower";
    StochasticEventType["exitedEmbeddedUpper"] = "exitedEmbeddedUpper";
    StochasticEventType["exitedEmbeddedLower"] = "exitedEmbeddedLower";
    StochasticEventType["newKLocalLow"] = "newKLocalLow";
    StochasticEventType["newKLocalHigh"] = "newKLocalHigh";
    StochasticEventType["newDLocalLow"] = "newDLocalLow";
    StochasticEventType["newDLocalHigh"] = "newDLocalHigh";
})(StochasticEventType || (StochasticEventType = {}));
//# sourceMappingURL=StochasticAnalyzerTypes.js.map